import * as React from 'react';
import { Heading } from '@restworld/ui-ds-base';
import { SkeletonTextLoading } from '../skeleton-loading';

import { cn } from '@restworld/utils-common';
export interface EmployerStatisticProps {
  count?: number;
  description?: string;
  label?: string;
  loading?: boolean;
}

export function EmployerStatistic({ count, description, label, loading }: EmployerStatisticProps) {
  return (
    <StatWrapper>
      <TitlesWrapper>
        {loading ? (
          <SkeletonTextLoading width="small" />
        ) : (
          <>
            <Heading as="span" size={5} weight="semibold" color="neutral" className="text-lg md:text-xl">
              {count?.toString()}
            </Heading>
            <Heading as="span" size={6} weight="semibold" color="neutral" className="text-sm pb-[3px] lowercase">
              {label}
            </Heading>
          </>
        )}
      </TitlesWrapper>
      {loading ? <SkeletonTextLoading width="medium" /> : <Description>{description}</Description>}
    </StatWrapper>
  );
}
export default EmployerStatistic;

const StatWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('!rounded-lg border-none bg-neutral-30 px-5 py-4', className)} {...props} />
);
const TitlesWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex items-end gap-2 mb-1', className)} {...props} />
);
const Description = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <p className={cn('text-neutral-200 text-sm font-medium', className)} {...props} />
);
